.wrapper {
  position: relative;
  width: 100%;
  background: var(--bg-inset);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  overflow: hidden;
  touch-action: none;
}

.canvas {
  display: block;
  width: 100%;
  cursor: crosshair;
}

.dragging {
  cursor: grabbing;
}

.readout {
  position: absolute;
  top: var(--space-2);
  right: var(--space-2);
  display: flex;
  gap: var(--space-3);
  padding: var(--space-1) var(--space-3);
  border-radius: var(--radius-sm);
  background: color-mix(in srgb, var(--bg-surface-raised) 88%, transparent);
  border: 1px solid var(--border-subtle);
  font-family: var(--font-mono);
  font-size: var(--text-2xs);
  color: var(--text-secondary);
  pointer-events: none;
  font-variant-numeric: tabular-nums;
}

.readoutValue {
  color: var(--text-primary);
}

.hint {
  position: absolute;
  bottom: var(--space-2);
  left: var(--space-3);
  font-size: var(--text-2xs);
  color: var(--text-tertiary);
  pointer-events: none;
}
